import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const steps = [
  {
    num: 1,
    titleKey: 'step_research_title',
    descKey: 'step_research_desc'
  },
  {
    num: 2,
    titleKey: 'step_verify_title',
    descKey: 'step_verify_desc'
  },
  {
    num: 3,
    titleKey: 'step_submit_title',
    descKey: 'step_submit_desc',
    cta: true
  },
  {
    num: 4,
    titleKey: 'step_confirm_title',
    descKey: 'step_confirm_desc'
  }
];

export default function AdmissionsSteps() {
  const { t } = useTranslation();

  return (
    <section className="animate-in fade-in slide-in-from-left-8 duration-700 delay-300">
      <h2 className="text-3xl font-playfair font-black text-navy mb-12 pb-4 border-b border-gray-100 flex items-center gap-4 italic uppercase tracking-tighter">
        {t('admissions_steps_title', 'Étapes pour postuler')}
      </h2>
      
      <div className="space-y-12 md:space-y-16">
        {steps.map((step) => (
          <div key={step.num} className="flex gap-8 relative">
            {/* Circle & Line */}
            <div className="flex flex-col items-center flex-shrink-0">
              <div className={`w-16 h-16 rounded-full flex items-center justify-center text-3xl font-black shrink-0 shadow-lg z-10 ${step.num === 1 ? 'bg-gold text-white' : 'bg-navy text-white'}`}>
                {step.num}
              </div>
              {step.num < 4 && (
                <div className="absolute left-8 top-16 bottom-[-64px] w-0.5 bg-gray-100 hidden md:block"></div>
              )}
            </div>

            {/* Content */}
            <div className="pb-8 md:pb-12">
              <h4 className="text-2xl font-black text-navy mb-4 uppercase tracking-tight">
                {t(step.titleKey)}
              </h4>
              <p className="text-gray-600 leading-relaxed font-medium text-lg max-w-3xl">
                {t(step.descKey)}
              </p>
              {step.cta && (
                <Link 
                  to="/admissions" 
                  className="mt-8 inline-block bg-gold text-white px-10 py-4 font-black uppercase text-sm tracking-widest shadow-xl hover:brightness-110 active:scale-95 transition-all"
                >
                  {t('hero_cta_apply', 'Postuler en ligne')}
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
